import { render, staticRenderFns } from "./stuApply.vue?vue&type=template&id=345e6c12&scoped=true&"
import script from "./stuApply.vue?vue&type=script&lang=js&"
export * from "./stuApply.vue?vue&type=script&lang=js&"
import style0 from "./stuApply.vue?vue&type=style&index=0&id=345e6c12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345e6c12",
  null
  
)

export default component.exports